export default "__VITE_ASSET__CzJanwZ6__"